import React, {useState } from 'react';
import { useSyles } from './step3.styles';
import Loading from '../../common/Loading';
import { useDispatch } from 'react-redux';
import { updateStep } from '../../../redux/auth/slice';
import { useStylesG } from '../Login/index.styles';
import { useStyles1 } from './step1.styles';
import Header from '../header';
import Button from 'src/components/common/Button';

const Step3 = () => {
  const classes = useSyles({ colorHeader: '#8FE779' });
  const classesG = useStylesG({});
  const classes1 = useStyles1({ colorHeader:"#014951"});

  const dispatch = useDispatch<any>();
  const [loading] = useState(false);

  const handleUpdateStep = (newStep:number) => {
    dispatch(updateStep(newStep));
  };

  return (
    <div className={classesG.container}>
      <Header title={"Herramientas de evidencia clínica"} 
              subtitle={"Explora herramientas fáciles de usar diseñadas por psicólogos."}
              colorHeader={"#014951"}
              heightHeader={'250px'}
      />
    
    <div className={classesG.body}>
        
        <div className={classes.content}>
        <img src="./images/Auth/Onboarding/01.png" alt="" />
        </div>
      </div>
      <div className={classes.footer}>
      {!loading ? (
           <div className={classes.buttons}>
              <Button onClick={()=>handleUpdateStep(4)} >
                <span >Siguiente</span>
              </Button>
           </div>
         ) : (
           <Loading height='150px' />
         )}
      </div>
    </div>
  );
};
export default Step3;
